/** @jsxImportSource @emotion/react */
import {
  Control,
  FieldErrors,
  FieldValues,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form"

import { FlexContainer } from "../../../../styled/flexbox.styled"
import { SCIENT_AGGRID_COLORS } from "../../../../styled/scientColors"
import {
  HeaderCell,
  TableContainer,
  TbodyContainer,
  TheadContainer,
  TrContainer,
} from "../../../../styled/table.styled"
import { MediumText } from "../../../../styled/text.styled"
import OrdersTableRow from "./components/OrdersTableRow"
import { OrdersColumn } from "./types/common"
import { OrderInputs, WaveInputs } from "./types/form"
import { ScientTradingAccount } from "../types"

interface OrdersTableProps {
  orders: OrderInputs[]
  accounts: ScientTradingAccount[]
  control: Control<FieldValues & WaveInputs>
  register: UseFormRegister<FieldValues & WaveInputs>
  deleteOrder: (index: number) => void
  copyPreviousOrder: (index: number) => void
  errors: FieldErrors<WaveInputs>
  watch: UseFormWatch<WaveInputs>
  directOrdersEnabled: boolean
  setValue: UseFormSetValue<WaveInputs>
  defaultOrder: OrderInputs
}

const OrdersTable = ({
  orders,
  accounts,
  control,
  register,
  deleteOrder,
  copyPreviousOrder,
  errors,
  watch,
  directOrdersEnabled,
  setValue,
  defaultOrder,
}: OrdersTableProps) => {
  return (
    <FlexContainer>
      <TableContainer gridTemplateColumns="30px repeat(12, 1fr) 2fr 30px">
        <TheadContainer>
          <TrContainer>
            <th />
            {(Object.keys(OrdersColumn) as Array<keyof typeof OrdersColumn>).map(colName => (
              <HeaderCell key={colName}>
                <MediumText color={SCIENT_AGGRID_COLORS.headerFont}>
                  {OrdersColumn[colName]}
                </MediumText>
              </HeaderCell>
            ))}
            {/* empty <th> as Delete Button header */}
            <th />
          </TrContainer>
        </TheadContainer>

        <TbodyContainer>
          {orders.map((order: OrderInputs, index: number) => (
            <TrContainer key={order.id}>
              <OrdersTableRow
                accounts={accounts}
                index={index}
                control={control}
                register={register}
                deleteOrder={deleteOrder}
                copyPreviousOrder={copyPreviousOrder}
                errors={errors}
                watch={watch}
                directOrdersEnabled={directOrdersEnabled}
                setValue={setValue}
                defaultOrder={defaultOrder}
              />
            </TrContainer>
          ))}
        </TbodyContainer>
      </TableContainer>
    </FlexContainer>
  )
}

export default OrdersTable
